/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecopsVulnerabilitySeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("SecopsVulnerabilitySeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return SecopsVulnerabilitySeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<SecopsVulnerabilitySeverityQueryOperator>): SecopsVulnerabilitySeverityQueryOperator {
        let obj = Object.assign(new SecopsVulnerabilitySeverityQueryOperator(), model);
        SecopsVulnerabilitySeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecopsVulnerabilitySeverityQueryOperator>): SecopsVulnerabilitySeverityQueryOperator {
        if (!model) return null;
        return SecopsVulnerabilitySeverityQueryOperator.newInstance(<SecopsVulnerabilitySeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecopsVulnerabilitySeverityQueryOperator) {
        if (!obj) return;

        models.SecopsVulnerabilitySeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecopsVulnerabilitySeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecopsVulnerabilitySeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Severity values to include
     */
    severity: Array<models.Severity>;

}
